<!--阅读说明-->
<div id="swipeContainer">
  <!--头部-->
  <div class="common-back-btn-sight closeBtn" (click)="close()" *ngIf="isOpenClass==0"></div>
  <!--标题-->
  <div class="reportTitle">
    <p class="courseName">{{courseName}}</p>
    <p class="title">{{pageTitle}}</p>
  </div>
  <!--阅读说明-->
  <div class="surveyCard" *ngIf="surveyStatus == 1">
    <p class="surveyCardTitle textCenter">{{staticDoc.title[3]}}</p>
    <p [innerHtml]="staticDoc['KAExplain'+cid]"></p>
    <img class="picture" style="width: 75%;margin-left: 12.5%;margin-top: .2rem" src="{{assetsRoute}}/picture/abilitysurvey/report/{{cid}}.png" alt="">
    <p [innerHtml]="staticDoc.instructions[0]"></p>
    <p [innerHtml]="staticDoc.instructions[1]"></p>
    <p [innerHtml]="staticDoc.instructions[2]"></p>
    <p [innerHtml]="staticDoc.instructions[3]"></p>
  </div>


  <div class="surveyCard" *ngIf="surveyStatus == 2">
    <p class="surveyCardTitle textCenter">{{staticDoc.title[2]}}</p>
    <p [innerHtml]="staticDoc.instructions[0]"></p>
    <p [innerHtml]="staticDoc.instructions[1]"></p>
    <p [innerHtml]="staticDoc.instructions[2]"></p>
    <p [innerHtml]="staticDoc.instructions[3]"></p>
  </div>

  <!--箭头-->
  <div id="bottomSpace">
    <div *ngIf="isPC && showPCBtn" class="pc-btn" (click)="goNext()">查看报告</div>
    <img *ngIf="!isPC" class="topArrow" src="{{assetsRoute}}/picture/reportnew/arrow.png" alt="">
  </div>
</div>

<app-com-tip *ngIf="isShowToast" [type]="'toast'" [desText]="promptText" [cancelText]="''" [sureText]="''" ></app-com-tip>

<!--报告-->
<div class="abilityReport">
  <!--头部-->
  <div class="common-back-btn-sight closeBtn" (click)="close()" *ngIf="isOpenClass==0"></div>
  <!--标题-->
  <div class="reportTitle">
    <p class="courseName">{{courseName}}</p>
    <p class="title">{{pageTitle}}</p>
  </div>
  <!--前测-->
  <div class="abilityFrontTest" *ngIf="surveyStatus == 1">
    <!--标题-->
    <div class="reportTitle">
      <p class="courseName">{{courseName}}</p>
      <p class="title">{{pageTitle}}</p>
    </div>
    <!--学前测评-->
    <div class="surveyItemCard first">
      <p class="surveyItemCardTitle">{{staticDoc.title[0]}}</p>
      <!--雷达图-->
      <div class="radarCharts" style="margin-top: 0 !important;" *ngIf="report">
        <ul class="mockYAxis">
          <li>6&nbsp;卓越</li>
          <li>5&nbsp;优秀</li>
          <li>4&nbsp;良好</li>
          <li>3&nbsp;一般</li>
          <li>2&nbsp;有限</li>
          <li>1&nbsp;薄弱</li>
        </ul>
        <div class="mockXAmis">
          <p class="first">您的成绩:</p>
          <p class="clearfix"><span style="float: left">● {{abilityName}}</span><span style="float:right">{{scoreStr}}</span></p>
        </div>
        <app-component-charts [chartsType]="chartsType" [theme]="theme" [isCamp]="true"
                              [chartsData]="chartKAsData" [max]="6"></app-component-charts>
      </div>
      <!--导师评语-->
      <div class="tutorWrap">
        <div class="tutorContent">
          <p>{{levelDesc}}</p>
        </div>
        <div class="teacherPhoto" *ngIf="teacherName">
          <img src="{{assetsRoute}}/picture/abilitysurvey/photo/{{teacherName}}.png" alt="">
        </div>
      </div>

    </div>

    <!--学习建议-->
    <div class="surveyItemCard">
      <div class="suggestHead">
        <div class="surveyItemCardTitle {{teacherName}}">{{staticDoc.title[2]}}</div>
      </div>

      <!--学习建议内容-->
      <div class="suggestContent">
        <div class="suggestDesc">{{suggest}}</div>
        <div class="suggestList" *ngFor="let item of learningTips;let i =index">
          <div class="title">
            <div>
              <span class="iconCircle" *ngIf="item.learningTipsTitle">{{i+1}}</span>
              {{item.learningTipsTitle}}
            </div>
          </div>
          <div class="content">{{item.learningTipsContent}}</div>
        </div>
      </div>
    </div>


    <div class="bottomBtn" (click)="getCourse()">完成学前检测</div>
    <div style="width: 100%;height: .3rem"></div>
  </div>

  <!--后测-->
  <div class="abilityAfterTest" *ngIf="surveyStatus == 2">
    <!--对比-->
    <div class="surveyItemCard first">
      <p class="surveyItemCardTitle multiLine">{{contrastSpeech}}</p>
      <!--雷达图-->
      <div class="radarCharts" style="margin-top: 0 !important;" *ngIf="report">
        <ul class="mockYAxis">
          <li>6&nbsp;卓越</li>
          <li>5&nbsp;优秀</li>
          <li>4&nbsp;良好</li>
          <li>3&nbsp;一般</li>
          <li>2&nbsp;有限</li>
          <li>1&nbsp;薄弱</li>
        </ul>


        <app-component-charts [chartsType]="chartsType" [theme]="theme" [isCamp]="true"
                              [chartsData]="chartKAsData" [max]="6"></app-component-charts>
      </div>
      <!--导师评语-->
      <div class="tutorWrap">
        <div class="tutorContent">
          <p>{{contrastDesc}}</p>
        </div>
        <div class="teacherPhoto" *ngIf="teacherName">
          <img src="{{assetsRoute}}/picture/abilitysurvey/photo/{{teacherName}}.png" alt="">
        </div>
      </div>

    </div>


    <!--后测表现好的KA-->
    <div class="surveyItemCard" *ngIf="a_advantagesKas&&a_advantagesKas.length!==0">
      <p class="surveyItemCardTitle multiLine w-75">以下<span
        class="text-orange">{{a_advantagesKas.length}}</span>个模块你表现得尤为出色</p>
      <div class="keyBehaviorIcon"><img src="{{assetsRoute}}/picture/abilitysurvey/type1.png" alt=""></div>
      <div class="keyBehaviorContent" *ngFor="let kas of a_advantagesKas;let i = index">
        <span class="labelStyle"><b>{{kas.learningTipsTitle}}</b></span><span>- {{kas.learningTipsContent}}</span>
      </div>
    </div>


    <!--仅存在待提高的KA-->
    <div class="surveyItemCard"
         *ngIf="(a_advantagesKas&&a_advantagesKas.length==0)&&(a_shortBoardsKas&&a_shortBoardsKas.length!==0)">
      <p class="surveyItemCardTitle multiLine w-75">你就是传说中的潜力股吧，未来成长空间巨大！</p>
      <div class="keyBehaviorIcon"><img src="{{assetsRoute}}/picture/abilitysurvey/type4.png" alt=""></div>
      <div class="keyBehaviorContent">{{advantagesFixedSpeech}}</div>
    </div>


    <!--后测待提高的KA-->
    <div class="surveyItemCard" *ngIf="a_shortBoardsKas&&a_shortBoardsKas.length!==0">
      <p class="surveyItemCardTitle multiLine w-75">以下<span class="text-red">{{a_shortBoardsKas.length}}</span>个模块还需<br>多多练习
      </p>
      <div class="keyBehaviorIcon"><img src="{{assetsRoute}}/picture/abilitysurvey/type2.png" alt=""></div>
      <div class="keyBehaviorContent" *ngFor="let kas of a_shortBoardsKas;let i = index">
        <span class="labelStyle"><b>{{kas.learningTipsTitle}}</b></span><span>- {{kas.learningTipsContent}}</span>
      </div>
    </div>


    <!--仅存在表现好的KA-->
    <div class="surveyItemCard"
         *ngIf="(a_shortBoardsKas&&a_shortBoardsKas.length==0)&&(a_advantagesKas&&a_advantagesKas.length!==0)">
      <p class="surveyItemCardTitle multiLine w-75">我们惊喜地发现，你暂时没有继续提高的模块！</p>
      <div class="keyBehaviorIcon"><img src="{{assetsRoute}}/picture/abilitysurvey/type3.png" alt=""></div>
      <div class="keyBehaviorContent">{{shortBoardsFixedSpeech}}</div>
    </div>

    <!--即不存在表现好的KA也不存在待提高的KA-->
    <div class="surveyItemCard"
         *ngIf="(a_shortBoardsKas&&a_shortBoardsKas.length==0)&&(a_advantagesKas&&a_advantagesKas.length==0)">
      <p class="surveyItemCardTitle multiLine w-75">你的各项行动展现都十分平稳，请再接再厉吧！</p>
      <div class="keyBehaviorIcon"><img src="{{assetsRoute}}/picture/abilitysurvey/type4.png" alt=""></div>
      <div class="keyBehaviorContent">{{fixedSpeech}}</div>
    </div>


    <!--发展建议-->
    <div class="surveyItemCard">
      <div class="suggestHead">
        <div class="surveyItemCardTitle {{teacherName}}">{{staticDoc.title[1]}}</div>
      </div>

      <!--发展建议内容-->
      <div class="suggestContent develop" *ngIf="developmentTipsKas&&developmentTipsKas.length!==0">
        <div class="content" [innerHTML]="developmentTipsTransition"></div>
        <div class="suggestList" *ngFor="let item of developmentTipsKas;let i = index">
          <div class="suggestList-partition" *ngIf="developmentTipsKas.length > 1"></div>
          <div class="serial-number-img" *ngIf="developmentTipsKas.length > 1"></div>
          <div class="serial-number" *ngIf="developmentTipsKas.length > 1">{{i + 1}}</div>
          <div class="content">
            <div class="content-title-develop">{{item.a_kaName}}</div>
            <div class="content-value">{{item.a_suggest}}</div>
            <div class="content-title-develop marginY-16">实用技巧</div>
            <div class="content-group" *ngFor="let child of item.a_skill">
              <div class="dot"></div><div class="content-value">{{child}}</div>
            </div>
            <div class="content-title-skill marginY-16">发展活动</div>
            <div class="content-group" *ngFor="let child of item.a_activ">
              <div class="dot"></div><div class="content-value">{{ child }}</div>
            </div>
          </div>
        </div>
      </div>

      <!--发展建议内容(不存在有待提高的KA)-->
      <div class="suggestContent develop" *ngIf="developmentTipsKas&&developmentTipsKas.length==0">
        <div class="suggestList" *ngFor="let item of developmentTipsFixedSpeech;let i = index">
          <div class="content" [innerHtml]="item"></div>
        </div>
      </div>

    </div>
    <div class="bottomBtn" (click)="getCourse()">完成综合考核</div>
    <div style="width: 100%;height: .3rem"></div>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/learning-camp/camp-survey-report/camp-survey-report.component.html